module.exports = __webpack_public_path__ + "static/media/chevron-down-nopad.31800331.svg";